import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledBureauxRequest: ['response'],
    getDisabledBureauxSuccess: ['response', 'loading'],
    getDisabledBureauxFailure: ['error'],
})

export const getDisabledBureauxTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledBureauxSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledBureauxFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledBureauxRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_BUREAUX_REQUEST]: getDisabledBureauxRequest,
    [Types.GET_DISABLED_BUREAUX_SUCCESS]: getDisabledBureauxSuccess,
    [Types.GET_DISABLED_BUREAUX_FAILURE]: getDisabledBureauxFailure,
})
